import type { InjectionKey, Ref } from 'vue';
import { inject, ref } from 'vue';

export enum THEME {
  DARK = 'dark',
  DARK_ALT = 'dark-alt',
  LIGHT = 'light',
  LIGHT_ALT = 'light-alt',
  APP = 'app',
}

export const themeList =[
  { title: 'Dark', value: THEME.DARK },
  { title: 'Dark Alt', value: THEME.DARK_ALT },
  { title: 'Light', value: THEME.LIGHT },
  { title: 'Light Alt', value: THEME.LIGHT_ALT },
];

export function themeName(themeValue: THEME) {
  return themeList.find((theme) => theme.value === themeValue)?.title;
}

export function themeClass(theme: THEME) {
  return `theme--${theme}`;
}

export type ProvideThemeInjection = {
  theme: Ref<THEME | undefined>;
  setTheme: (theme: THEME) => void;
};

export const PROVIDE_THEME = Symbol('PROVIDE_THEME') as InjectionKey<ProvideThemeInjection>;

export const useTheme = () => {
  return inject(PROVIDE_THEME) as ProvideThemeInjection;
};
